import React, {Component} from 'react';
import {StyleSheet, View, Text, Platform, Alert, TextInput} from 'react-native';
import colors from '../../HelperClasses/AppColor';
import appConfigStyle from '../../StyleSheets/AppConfigStyleSheet';
import PropTypes from 'prop-types';
import tableStyle from '../../StyleSheets/TableCommonStyleSheet';
import CommonStyleSheet from '../../StyleSheets/CommonStyleSheet';
import networkService from '../../Network/NetworkManager';
import Appload from '../../HelperClasses/AppLoaderClasses/AppLoader';
import {AppToast} from '../../HelperClasses/AppToast';
import Switch from 'react-switch';
import SelectSearchView from 'react-select';
import LocaleContext from '../../Localization/LocaleContext';
import {readCheckoutSettingsDraft, writeCheckoutSettingsDraft, clearCheckoutSettingsDraft} from './checkoutSettingsDrafts';

const AppConstants = require('../../Constants/AppConstants');

const APPURL = require('../../Constants/URLConstants');
const KeyGroup = 'orders';
const ORDER_STATUS_OPTIONS = [
  {label: 'Placed success', value: 2},
  {label: 'In process', value: 3},
  {label: 'Shipped', value: 4},
  {label: 'Delivered', value: 5},
  {label: 'Completed', value: 8},
];
export default class OrdersSettings extends Component {
  static contextType = LocaleContext;
  t = (key, fallback) => this.context?.translate?.(key, fallback) || fallback || key;
  constructor(props) {
    super(props);
    const draft = readCheckoutSettingsDraft('orderAttributes');
    this.state = {
      subMenuSelectedIndex: 0,
      geoCodeKey: '',
      updateUI: false,
      dataLoad: false,
      statusArray: Array.isArray(draft.statusArray) ? draft.statusArray : [false],
      returnPolicyDays: draft.returnPolicyDays || '',
      regexp: /^[0-9\.]+$/,
      cartAttributeStatuses: Array.isArray(draft.cartAttributeStatuses) ? draft.cartAttributeStatuses : [],
    };
  }
  static propTypes = {
    backBtn: PropTypes.func,
    compact: PropTypes.bool,
  };
  componentDidMount() {
    this.loadConfigApi();
  }
  componentDidUpdate() {
    if (this.draftReady && !this.draftCleared) {
      writeCheckoutSettingsDraft('orderAttributes', {
        statusArray: this.state.statusArray,
        returnPolicyDays: this.state.returnPolicyDays,
        cartAttributeStatuses: this.state.cartAttributeStatuses,
      });
    }
  }
  //MARK:-  APIs Method 
  loadConfigApi = async () => {
    const responseJson = await networkService.networkCall(
      APPURL.URLPaths.config + '?key_group=' + KeyGroup,
      'get',
    );
    const draft = readCheckoutSettingsDraft('orderAttributes');
    if (responseJson['status'] == true) {
      var configs = responseJson['data']['configs'];
      const savedStatuses =
        configs['show_cart_attributes_order_status'] || [];
      this.setState({
        statusArray: draft.statusArray ?? [configs[keyParameterArray[0]] ?? false],
        returnPolicyDays: draft.returnPolicyDays ?? configs['return_policy_days'] ?? '',
        cartAttributeStatuses: draft.cartAttributeStatuses ?? (Array.isArray(savedStatuses)
          ? savedStatuses
          : []),
      });
    }
    this.draftReady = true;
    this.setState({dataLoad: true});
  };
  addOrUpdateAppDetailApi = async () => {
    var configs = [];
    for (let i = 0; i < keyParameterArray.length; i++) {
      const key = keyParameterArray[i];
      let value = null;
      if (key === 'show_orders_view_type') {
        value = this.state.statusArray[0];
      } else if (key === 'return_policy_days') {
        value = this.state.returnPolicyDays;
      } else if (key === 'show_cart_attributes_order_status') {
        value = this.state.cartAttributeStatuses || [];
      }
      let fDict = {
        key_group: KeyGroup,
        key: key,
        value: value,
        secured: false,
      };
      configs.push(fDict);
    }
    if (configs.length != 0) {
      const responseJson = await networkService.networkCall(
        APPURL.URLPaths.config,
        'post',
        JSON.stringify({configs: configs}),
      );
      if (responseJson['status'] == true) {
        this.draftCleared = true;
        clearCheckoutSettingsDraft('orderAttributes');
        return this.deleteKeysAPI(configs);
      } else {
        this.setState({dataLoad: true});
      }
    } else {
      return this.deleteKeysAPI(configs);
    }
  };
  deleteKeysAPI = async Parameter => {
    var deleteParms = [];
    for (let q = 0; q < keyParameterArray.length; q++) {
      deleteParms.push(keyParameterArray[q]);
    }

    for (let a = 0; a < Parameter.length; a++) {
      let name = Parameter[a]['key'];
      let index = deleteParms.indexOf(name);
      deleteParms.splice(index, 1);
    }

    if (deleteParms.length != 0) {
      let parms = deleteParms.toString();
      let urlParm = APPURL.URLPaths.config + '?key=' + parms;
      const responseJson = await networkService.networkCall(urlParm, 'delete');
      this.setState({dataLoad: true});
      this.alertView('Uploaded successfully');
    } else {
      this.setState({dataLoad: true});
      this.alertView('Uploaded successfully');
    }
  };
  alertView(title) {
    AppToast();
  }
  //MARK:-  Buttons Action Method 
  saveBtnAction() {
    this.setState({dataLoad: false});
    return this.addOrUpdateAppDetailApi();
  }
  switchSattusBtnAction(id) {
    this.setState(prevState => {
      const statusArray = [...prevState.statusArray];
      statusArray[id] = !statusArray[id];
      return {statusArray};
    });
  }
  renderAllSwitches = props => {
    var views = [];
    for (let i = 0; i < switchTitleStrings.length; i++) {
      views.push(
        <View style={{flexDirection: 'row', flexWrap: 'wrap', marginTop: 20}}>
          <Switch
            onColor={colors.AppNewGreen}
            onChange={() => this.switchSattusBtnAction(i)}
            checked={this.state.statusArray[i]}
            height={22}
            width={50}
          />
          <Text style={[appConfigStyle.statusTxtStyle, this.props.compact && styles.compactStatusText]}>
            {this.t(`checkout_settings.orders_option_${i}`, switchTitleStrings[i])}
          </Text>
        </View>,
      );
    }
    return views;
  };
  onHandleTextChange = text => {
    let value = text;
    if (text == '' || this.state.regexp.test(value)) {
      this.setState({returnPolicyDays: text});
    }
  };
  //MARK:-  UI 
  render() {
    return (
      <View
        style={
          this.props.compact
            ? styles.compactContainer
            : {width: '70%', marginBottom: 130, marginLeft: 10}
        }>
        {!this.props.compact && <Text style={tableStyle.listTitleText}>{this.t('checkout_settings.orders', 'Orders')}</Text>}
        {!this.props.compact && (
          <Text style={appConfigStyle.subTitleStyle}>
            {AppConstants.plainTextString}
          </Text>
        )}
        {!this.props.compact && (
          <View style={appConfigStyle.horizontalLineViewStyle} />
        )}
        <View
          style={[
            appConfigStyle.subViewStyle,
            this.props.compact && styles.compactSubView,
          ]}>
          <View style={{flexDirection: 'column', flex: 1.5}}>
            {/* <View style={{marginTop: -20}}>
              <Text style={appConfigStyle.titleTxtStyle}>
                Reverse Geocode Api
              </Text>
              <TextInput
                style={appConfigStyle.txtFieldStyle}
                placeholder="Enter Reverse Geocode Api"
                placeholderTextColor={colors.placeholderColor}
                onChangeText={text => this.setState({geoCodeKey: text})}
                value={this.state.geoCodeKey}
              />
            </View> */}
            <View style={{marginTop: this.props.compact ? 0 : -50}}>
              <this.renderAllSwitches />
            </View>
            <View style={{marginTop: this.props.compact ? 12 : 20}}>
              <Text style={appConfigStyle.titleTxtStyle}>
                {this.t('checkout_settings.return_policy_days', 'Return policy days')}
              </Text>
              <TextInput
                style={[
                  this.props.compact
                    ? styles.shadcnInput
                    : CommonStyleSheet.fulltxtFieldStyle,
                  {outline: 0},
                ]}
                placeholder={this.t('checkout_settings.enter_return_policy_days', 'Enter return policy days')}
                placeholderTextColor={colors.placeholderColor}
                onChangeText={text => this.onHandleTextChange(text)}
                value={this.state.returnPolicyDays}
              />
            </View>
            <View style={{marginTop: this.props.compact ? 12 : 20}}>
              <Text style={appConfigStyle.titleTxtStyle}>
                {this.t('checkout_settings.show_cart_attributes', 'Show cart attributes')}
              </Text>
              <View style={{marginTop: 5}}>
                <SelectSearchView
                  value={ORDER_STATUS_OPTIONS.filter(option =>
                    this.state.cartAttributeStatuses.includes(option.value),
                  )}
                  onChange={selected => {
                    const values = selected
                      ? selected.map(option => option.value)
                      : [];
                    this.setState({cartAttributeStatuses: values});
                  }}
                  options={ORDER_STATUS_OPTIONS.map((option, index) => ({...option, label: this.t(`checkout_settings.order_status_${index}`, option.label)}))}
                  isMulti={true}
                  placeholder={this.t('checkout_settings.select_order_status', 'Select order status')}
                  menuPortalTarget={
                    typeof document !== 'undefined' ? document.body : undefined
                  }
                  styles={{
                    menuPortal: base => ({...base, zIndex: 9999}),
                    menu: base => ({...base, zIndex: 9999}),
                  }}
                />
              </View>
            </View>
          </View>
        </View>
        {!this.props.compact && <Appload enable={this.state.dataLoad} />}
      </View>
    );
  }
}
const styles = StyleSheet.create({
  Container: {
    flex: 1,
    backgroundColor: 'white',
  },
  verifyEmailStyle: {
    height: 30,
    width: 150,
    backgroundColor: colors.AppNewGreen,
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: 5,
    shadowColor: colors.Appgray,
    shadowOpacity: 0.5,
    shadowOffset: {width: 0, height: 0},
    shadowRadius: 5,
  },
  compactContainer: {
    width: '100%',
    marginBottom: 10,
    marginLeft: 0,
  },
  shadcnInput: {
    width: '100%',
    height: 40,
    marginTop: 6,
    paddingHorizontal: 12,
    paddingVertical: 8,
    backgroundColor: '#ffffff',
    color: '#0f172a',
    fontSize: 14,
    lineHeight: 20,
    borderWidth: 1,
    borderColor: '#e2e8f0',
    borderRadius: 6,
  },
  compactSubView: {
    marginTop: 0,
    marginRight: 0,
    marginLeft: 0,
    marginBottom: 4,
  },
  compactStatusText: {
    flex: 1,
    marginLeft: 12,
    lineHeight: 20,
  },
});

const switchTitleStrings = ['Orders Calendar View'];
let keyParameterArray = [
  'show_orders_view_type',
  'return_policy_days',
  'show_cart_attributes_order_status',
];
